<template>
  <message v-if="show" ref="message" :title="mes">
    <div slot="body">
      <table class="table table-striped table-bordered">
        <thead class="thead-light">
        <tr>
          <th>SUCURSAL</th>
          <th>VENTAS AÑO ANTERIOR {{anio_anterior}}</th>
          <th>VENTAS AÑO ACTUAL {{anio_actual}}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in dataMes">
          <td>{{$store.getters.sucursal(item.sucursal_id).nombre | upper}}</td>
          <td>{{item.venta_anio_anterior | currency}}</td>
          <td>{{item.venta_actual | currency}}</td>
        </tr>
        </tbody>
      </table>
      <button class="btn btn-danger btn-micro mt-5 pull-right" @click="closeMessage">Close</button>
    </div>
  </message>
</template>

<script>
  import Message from "../../Componentes_Globales/message/Message";
  import makeQuery from "../../../api/helper";

  export default {
    props: ["mes", "anio_actual", "anio_anterior"],
    name: "miniModalMes",
    data() {
      return {show: false, dataMes: []}
    },
    methods: {
      openMessage(item) {
        this.show = false
        setTimeout(() => {
          this.show = true
          this.getData(item)
        }, 100)
      },
      closeMessage() {
        this.show = false
      },
      getData(item) {
        const query = this.crearQuery(item)
        this.$axios.get("finanzas/consolidado-ventas" + query)
        .then(({data}) => this.dataMes = data.items)
        .catch(console.error)
      },
      crearQuery(item) {
        return makeQuery({
          filtros: [
            {field: "mes", value: item.mes, operator: "CONTAINS"},
            {field: "anio", value: this.anio_actual, operator: "="},
            {field: "anioAnterior", value: this.anio_anterior, operator: "="},
          ]
        })
      }
    },
    components: {Message}
  }
</script>

<style scoped>

</style>
